<div class="w-full" [attr.data-testid]="id">
  @if (label) {
    <span class="block mb-1 text-[12px] font-medium text-[#728197] font-poppins leading-[18px]">
      {{ label }}
    </span>
  }

  <div class="relative w-full" (click)="toggleDropdown()" (keydown.enter)="toggleDropdown()">
    <button
      type="button"
      [attr.data-testid]="id"
      [disabled]="isReadonly"
      class="flex items-center justify-between w-full px-4 text-left rounded-2xl focus:outline-none"
      [ngClass]="{
        'h-10': size === 'small',
        'h-12': size === 'medium',
        'bg-[#E7EDF466] border-none placeholder:font-medium placeholder:text-soft-gray': isReadonly,
        'border-negative border-2': !isReadonly && isInvalid,
        'bg-white border border-soft-gray': !isReadonly && !isInvalid
      }">

      <span
        class="flex-1 min-w-0 truncate font-poppins text-base leading-6"
        [ngClass]="selectedOption() ? 'text-text-primary font-medium' : 'text-[#B6C2D3] font-normal'"
        [customTooltip]="selectedOption()?.label ?? ''"
        [showOnlyWhenTruncated]="true"
        [tooltipPosition]="'top'"
      >
        {{ selectedOption()?.label ?? placeholder }}
      </span>

      @if (!isReadonly) {
        @if (!isOpen()) {
          <i class="fi fi-rr-angle-down leading-none pt-[2px]"></i>
        } @else {
          <i class="fi fi-rr-angle-up pt-[2px]"></i>
        }
      }
    </button>

    @if (!isReadonly && isOpen()) {
      <div class="absolute z-10 w-full mt-1 border border-soft-gray rounded-2xl shadow overflow-hidden">
        <ul class="bg-white max-h-60 overflow-y-auto">
          @for (option of options; track $index) {
            <li
              (click)="selectOption(option, $event)"
              (keydown.enter)="selectOption(option, $event)"
              [attr.aria-disabled]="option.disabled ? 'true' : null"
              [customTooltip]="option.disabled && option.tooltip ? option.tooltip : ''"
              [showOnlyWhenTruncated]="false"
              [tooltipPosition]="'right'"
              class="px-4 py-2 flex items-start justify-between gap-2"
              [ngClass]="option.disabled
                ? 'cursor-not-allowed text-[#9AA8BC] bg-[#F5F7FA]'
                : 'cursor-pointer hover:bg-primary-g300 hover:text-[#FFFFFF]'">
              <span class="block whitespace-normal break-words">{{ option.label }}</span>
              @if (option.disabled) {
                <span class="font-poppins text-[10px] font-medium text-[#9AA8BC] bg-white border border-[#CBD4E1] rounded-full px-2 py-[2px] whitespace-nowrap">
                  Próximamente
                </span>
              }
            </li>
          }
        </ul>
      </div>
    }
  </div>

  @if (isInvalid) {
    <div class="flex items-center ml-3 mt-1">
      <i class="fi fi-sr-triangle-warning text-negative mr-1 text-[13px] flex-shrink-0 h-4"></i>
      <p class="font-poppins font-normal text-[12px] text-start leading-tight text-[#B1000F]">
        {{ control.errors | formError }}
      </p>
    </div>
  }
</div>
